export default __webpack_public_path__ + "static/media/buckets-icon.3a757101.svg";